import { register } from "@shopify/theme-sections";
import Slider from "../components/slider/slider";
import YouTubePlayer from "youtube-player";
import VimeoPlayer from "@vimeo/player";

const selectors = {
	slider: "[data-top-slider]",
	pagination: "[data-slider-pagination]",
	slideCoverImage: "slider__slide-video-cover-image"
};

register("top-slider", {
	slider: null,
	options: {},
	onLoad: function () {
		this.sliderContainer = this.container.querySelector(selectors.slider);

		if (!this.sliderContainer) {
			return null;
		}

		this.options = {
			autoplay: {
				delay: 10000
			},
			navigation: false,
			pagination: {
				el: selectors.pagination,
				clickable: true,
				type: "bullets"
			},
			on: {
				afterInit: () => {
					if (this.isSlideContainsVideo()) {
						this.handleVideo();
					}
				},
				slideChange: () => {
					if (this.isSlideContainsVideo()) {
						this.handleVideo();
					}
				}
			}
		};

		this.slider = new Slider(this.sliderContainer, this.options);
	},
	onUnload: function () {
		if (!this.slider) {
			return null;
		}

		this.slider.destroy();
	},
	isSlideContainsVideo: function () {
		return (
			this.getCurrentSlideChildren()[0].getAttribute(
				"data-video-player"
			) !== null
		);
	},
	getInstance: function () {
		return this.sliderContainer.swiper;
	},
	getCurrentSlide: function () {
		return this.getInstance().slides[this.getInstance().activeIndex];
	},
	getCurrentSlideChildren: function () {
		return [].slice.call(this.getCurrentSlide().children);
	},
	getCurrentSlideVideoElement: function () {
		return this.getCurrentSlideChildren()[0];
	},
	handleVideo: function () {
		let self = this;
		this.getCurrentSlide().style.pointerEvents = "none";

		if (this.getVideoType() === "youtube") {
			let youtubeVideoPlayer = YouTubePlayer("js-youtube-player", {
				width: "100%",
				height: "100%",
				playerVars: {
					autoplay: 1,
					controls: 0,
					playsinline: 1,
					loop: 1,
					disablekb: 1,
					modestbranding: 1,
					showinfo: 0
				}
			});
			youtubeVideoPlayer.on("ready", () => {
				youtubeVideoPlayer.loadVideoById(this.getVideoId());
				youtubeVideoPlayer.loadPlaylist(this.getVideoId());
				youtubeVideoPlayer.setLoop(true);
				youtubeVideoPlayer.mute();
				youtubeVideoPlayer.playVideo();
				self.coverImage("hide");
			});
			youtubeVideoPlayer.on("error", () => {
				self.coverImage("show");
			});
		} else {
			let vimeoVideoPlayer = new VimeoPlayer(
				document.querySelector("#js-vimeo-player"),
				{
					id: self.getVideoId(),
					width: "100%",
					height: "100%",
					autoplay: true,
					controls: false,
					title: 0,
					byline: 0,
					sidedock: 0,
					background: 1
				}
			);

			vimeoVideoPlayer
				.ready()
				.then(function () {
					vimeoVideoPlayer.setLoop(true);
					vimeoVideoPlayer.setMuted(true);
					vimeoVideoPlayer.play();
					vimeoVideoPlayer.disableTextTrack();
					self.coverImage("hide");
				})
				.catch(function () {
					self.coverImage("show");
				});
		}
	},
	getVideoId: function () {
		let slideChildrenAsArray = [].slice.call(
			this.getCurrentSlide().children
		);

		for (let index = 0; index < slideChildrenAsArray.length; index++) {
			let element = slideChildrenAsArray[index];
			return element.getAttribute("data-video-id");
		}
	},
	getVideoType: function () {
		return this.getCurrentSlideVideoElement().id.includes("youtube")
			? "youtube"
			: "vimeo";
	},
	coverImage: function (action) {
		if (
			!this.getCurrentSlide().getElementsByClassName(
				selectors.slideCoverImage
			)
		) {
			return null;
		}

		let coverImage = this.getCurrentSlide().getElementsByClassName(
			selectors.slideCoverImage
		)[0];

		if (action === "hide") {
			coverImage.style.display = "none";
		} else {
			coverImage.style.display = "block";
		}
	}
});
